module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/text-width-cd076bf427c9fba09fe29472b72a27a3.svg";